import {
    getValue,
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
    TranslateParser
} from "@ngx-translate/core";
import { inject, Injectable } from "@angular/core";
import { LG_BASE_TRANSLATIONS } from "./lg-translate-startup.service";

@Injectable()
export class LgMissingTranslationHandler implements MissingTranslationHandler {
    translations = inject(LG_BASE_TRANSLATIONS) ?? {};
    private readonly _parser = inject(TranslateParser);

    handle(params: MissingTranslationHandlerParams): string {
        const { key, interpolateParams } = params;
        return (
            this._parser.interpolate(
                getValue(this.translations, key) as string,
                interpolateParams
            ) ?? key
        );
    }
}
